import { GenerateChannelForecastComponent } from "./component";

export const GenerateChannelForecastContainer = () => {
  return <GenerateChannelForecastComponent />;
};
